export default __webpack_public_path__ + "static/media/expBlue.159c6388.svg";